export default __webpack_public_path__ + "static/media/food-logo.eb8d0cf1.png";